(function () {
  Flint.file('views/heroCarousel.js', function (require) {
    Flint.staticStyles('HeroCarousel', {
      '$': '#_flintapp .ViewHeroCarousel'
    }, {
      '$': {
        alignItems: 'center'
      }
    });
    Flint.view('HeroCarousel', function (view, on, $) {
      var context = initContext(view, {
        colors: atom(),
        width: atom(),
        isMobile: atom()
      });

      var pro = initPro(view, {
        children: atom(),
        autoSwipeInterval: M.defaultAtom(8000),
        stopAfterUserHasSwiped: M.defaultAtom(true)
      });

      var selectedIndex = atom(0);
      var timeSinceSwipe = atom(0);
      var userHasSwiped = atom(false);

      on.every(1000, function () {
        timeSinceSwipe.set(timeSinceSwipe.get() + 1000);
        if (userHasSwiped.get() && pro.stopAfterUserHasSwiped.get()) return;

        if (pro.autoSwipeInterval.get() && timeSinceSwipe.get() >= pro.autoSwipeInterval.get()) {
          transact(function () {
            selectedIndex.set((selectedIndex.get() + 1) % React.Children.count(pro.children.get()));
            timeSinceSwipe.set(0);
          });
        }
      });

      var buttonWidth = derivation(function () {
        return context.isMobile.get() ? 0 : 50;
      });view.render(function () {
        return view.el(
          ['Carousel', 1],
          {
            width: context.width.get(),
            height: (context.width.get() - 2 * buttonWidth.get()) / 2.63,
            buttonWidth: buttonWidth.get(),
            showButtons: !context.isMobile.get(),
            wrapMode: 'cylinder',
            shadows: true,
            selectedIndex: userHasSwiped.get() && pro.stopAfterUserHasSwiped.get() ? null : selectedIndex.get(),
            onSelect: function (e) {
              selectedIndex.set(e.selectedIndex);
              on.delay(100, function () {
                userHasSwiped.set(true);
                timeSinceSwipe.set(0);
              });
            },
            style: {
              button: {},
              buttonHover: {
                color: context.colors.get().accent
              },
              dots: {
                bottom: context.isMobile.get() ? -22 : -28
              },
              border: '1px solid #eee',
              borderRadius: 8
            }
          },
          pro.children.get()
        );
      });

      $["$"] = function (_, _index) {
        return { width: context.width.get(),
          paddingBottom: context.isMobile.get() ? 42 : 50
        };
      };
    });
  })
})();
//# sourceMappingURL=heroCarousel.js.map
